// extracted by mini-css-extract-plugin
module.exports = {"title":"W2Mistakes_title__ctiT9","items":"W2Mistakes_items__pGI4V"};